//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DateUtils from './utils/DateUtils.js'
import DateLanguages from './utils/DateLanguages.js'
import moment from 'moment'

export default {
  props: {
    value: {
      type: [Date, String],
      default: null
    },
    name: {
      type: String,
      default: null
    },
    disableInput: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    format: {
      type: String,
      default: 'dd MMM yyyy'
    },
    language: {
      type: String,
      default: 'en'
    },
    disabled: {
      type: Object,
      default: null
    },
    highlighted: {
      type: Object,
      default: null
    },
    placeholder: {
      type: String,
      default: 'JJ/MM/AAAA'
    },
    inline: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String,
      default: null
    },
    wrapperClass: {
      type: [Object, String],
      default: null
    },
    iconClass: {
      type: String,
      required: false,
      default: null
    },
    sizeClass: {
      type: String,
      required: false,
      default: null
    },
    iconName: {
      type: String,
      required: false,
      default: null
    },
    poptipTitle: {
      type: String,
      required: false,
      default: null
    },
    poptipContent: {
      type: String,
      required: false,
      default: null
    },
    mondayFirst: {
      type: Boolean,
      default: false
    },
    clearButton: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: true
    },
    monthPicker: {
      type: Boolean,
      default: false
    },
    preAddon: {
      type: String,
      default: null
    },

  },

  data () {
    return {
      /*
       * Vue cannot observe changes to a Date Object so date must be stored as a timestamp
       * This represents the first day of the current viewing month
       * {Number}
       */
      currDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime(),
      /*
       * Selected Date
       * {Date}
       */
      selectedDate: null,
      /*
       * Flags to show calendar views
       * {Boolean}
       */
      showDayView: false,
      showMonthView: false,
      showYearView: false,
      /*
       * Helper arrays for names
       */
      /*
       * Positioning
       */
      calendarHeight: 0,
      intervalTimer: null
    }
  },

  computed: {

    formattedValue () {
      if (!this.selectedDate) {
        return null
      }
      return DateUtils.formatDate(new Date(this.selectedDate), this.format, this.translation)
    },
    translation () {
      return DateLanguages.translations[this.language]
    },
    currMonthName () {
      const d = new Date(this.currDate)
      return DateUtils.getMonthName(d.getMonth(), this.translation.months.original)
    },
    currYear () {
      const d = new Date(this.currDate)
      return d.getFullYear()
    },
    /**
     * Returns the day number of the week less one for the first of the current month
     * Used to show amount of empty cells before the first in the day calendar layout
     * @return {Number}
     */
    blankDays () {
      const d = new Date(this.currDate)
      let dObj = new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes())
      if (this.mondayFirst) {
        return dObj.getDay() > 0 ? dObj.getDay() - 1 : 6
      }
      return dObj.getDay()
    },
    daysOfWeek () {
      if (this.mondayFirst) {
        const tempDays = this.translation.days.slice()
        tempDays.push(tempDays.shift())
        return tempDays
      }
      return this.translation.days
    },
    days () {
      const d = new Date(this.currDate)
      let days = []
      // set up a new date object to the beginning of the current 'page'
      let dObj = new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes())
      let daysInMonth = DateUtils.daysInMonth(dObj.getFullYear(), dObj.getMonth())
      for (let i = 0; i < daysInMonth; i++) {
        days.push({
          date: dObj.getDate(),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedDate(dObj),
          isDisabled: this.isDisabledDate(dObj),
          isHighlighted: this.isHighlightedDate(dObj)
        })
        dObj.setDate(dObj.getDate() + 1)
      }
      return days
    },
    months () {
      const d = new Date(this.currDate)
      let months = []
      // set up a new date object to the beginning of the current 'page'
      let dObj = new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes())
      for (let i = 0; i < 12; i++) {
        months.push({
          month: DateUtils.getMonthName(i, this.translation.months.original),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedMonth(dObj),
          isDisabled: this.isDisabledMonth(dObj)
        })
        dObj.setMonth(dObj.getMonth() + 1)
      }
      return months
    },
    years () {
      const d = new Date(this.currDate)
      let years = []
      // set up a new date object to the beginning of the current 'page'
      let dObj = new Date(Math.floor(d.getFullYear() / 10) * 10, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes())
      for (let i = 0; i < 10; i++) {
        years.push({
          year: dObj.getFullYear(),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedYear(dObj),
          isDisabled: this.isDisabledYear(dObj)
        })
        dObj.setFullYear(dObj.getFullYear() + 1)
      }
      return years
    },
    calendarStyle () {
      let elSize = {
        top: 0,
        height: 0
      }
      if (this.$el) {
        elSize = this.$el.getBoundingClientRect()
      }
      let heightNeeded = elSize.top + elSize.height + this.calendarHeight || 0
      let styles = {}
      // if the calendar doesn't fit on the window without scrolling position it above the input
      if (heightNeeded > window.innerHeight) {
        styles = {
          'bottom': elSize.height + 'px'
        }
      }
      if (this.isInline()) {
        styles.position = 'static'
      }

      return styles
    },
    calendarStyleSecondary () {
      return (this.isInline()) ? { 'position': 'static' } : {}
    }
  },

  watch: {
    value (value) {
      this.setValue(value)
    }
  },

  /**
   * Vue 2.x
   */
  mounted () {
    this.init()
  },

  /**
   * Vue 2.x
   */
  destroyed () {
    this.$bus.$off('focus-field')
    this.$bus.$off('blur-field')

    clearInterval(this.intervalTimer)
    document.removeEventListener('click', this.onDocumentClick)
  },

  methods: {
    close () {
      this.showDayView = this.showMonthView = this.showYearView = false
    },
    isOpen () {
      return this.showDayView || this.showMonthView || this.showYearView
    },
    isInline () {
      return this.inline === true
    },
    showCalendar () {
      if (this.isInline()) {
        return false
      }
      if (this.isOpen() && this.readonly) {
        return this.close()
      }
      if (this.monthPicker) {
        this.showMonthCalendar()
      } else {
        this.showDayCalendar()
      }
    },

    onKeyUp (key) {
      if (this.$refs.date) {
        if (key !== undefined && key.code !== 'Backspace') {
          const str = this.autoCompleteDate(this.$refs.date.value).slice(0, 10)

          if (str !== this.$refs.date.value) {
            this.$refs.date.value = str
          }
        }
        const format = this.monthPicker ? 'MM/YYYY' : 'DD/MM/YYYY'
        const date = moment(this.$refs.date.value, format)

        if (!isNaN(date.valueOf()) && (this.$refs.date.value.length === 10 || this.monthPicker && this.$refs.date.value.length === 7)) {
          this.setDate(date.valueOf())
        }
      }
    },
    autoCompleteDate (str) {
      let looksLike_MM_slash_DD = /^(\d\d\/)?\d\d$/,
          looksLike_MM_slash_D_slash = /^(\d\d\/)?(\d\/)$/,
          looksLike_MM = /^(\d\d)$/

      if (!this.monthPicker) {
        if (looksLike_MM_slash_DD.test(str))
          str += '/'
        else if (looksLike_MM_slash_D_slash.test(str))
          str = str.replace(looksLike_MM_slash_D_slash, '$10$2')
      } else {
        if (looksLike_MM.test(str))
          str += '/'
      }

      return str
    },

    /**
     * @param {Object} event
     */
    onKeyDown (event) {
      if (event.key === 'Enter') {
        this.close()
        this.$bus.$emit('focus-next-field', this.id)
      } else if (event.key === 'Tab') {
        this.close()
      }
    },

    /**
     * @param {String} id
     */
    focusField (id) {
      if (id === this.id && this.$refs.date) {
        this.$refs.date.focus()
        this.showDayView = !this.monthPicker
      }
    },

    /**
     * @param {String} id
     */
    blurField (id) {
      if (id === this.id && this.$refs.date) {
        this.$refs.date.blur()
      }
    },

    showDayCalendar () {
      this.close()
      this.showDayView = true
      this.$emit('opened')
    },
    showMonthCalendar () {
      this.close()
      this.showMonthView = true
    },
    showYearCalendar () {
      this.close()
      this.showYearView = true
    },

    setDate (timestamp) {
      this.selectedDate = new Date(timestamp)
      this.currDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1).getTime()
      this.$emit('selected', new Date(timestamp))
      this.$emit('input', new Date(timestamp))
      this.close()
      this.$bus.$emit('focus-next-field', this.id)
    },

    clearDate () {
      this.selectedDate = null
      this.$emit('selected', this.selectedDate)
      this.$emit('cleared')
    },

    /**
     * @param {Object} day
     */
    selectDate (day) {
      if (day.isDisabled) {
        return false
      }
      this.setDate(day.timestamp)
      if (this.isInline()) {
        return this.showDayCalendar()
      }
      this.close()
    },

    /**
     * @param {Object} month
     */
    selectMonth (month) {
      if (month.isDisabled) {
        return false
      }
      this.currDate = month.timestamp
      if (!this.monthPicker) {
        this.showDayCalendar()
      } else {
        this.setDate(month.timestamp)
      }
    },

    /**
     * @param {Object} year
     */
    selectYear (year) {
      if (year.isDisabled) {
        return false
      }
      this.currDate = year.timestamp
      this.showMonthCalendar()
    },

    /**
     * @return {Number}
     */
    getMonth () {
      let d = new Date(this.currDate)
      return d.getMonth()
    },

    /**
     * @return {Number}
     */
    getYear () {
      let d = new Date(this.currDate)
      return d.getFullYear()
    },

    /**
     * @return {String}
     */
    getDecade () {
      let d = new Date(this.currDate)
      let sD = Math.floor(d.getFullYear() / 10) * 10
      return sD + '\'s'
    },

    previousMonth () {
      if (this.previousMonthDisabled()) {
        return false
      }
      let d = new Date(this.currDate)
      d.setMonth(d.getMonth() - 1)
      this.currDate = d.getTime()
      this.$emit('changedMonth', d)
    },

    previousMonthDisabled () {
      if (this.disabled === null || typeof this.disabled === 'undefined' || typeof this.disabled.to === 'undefined' || !this.disabled.to) {
        return false
      }
      let d = new Date(this.currDate)
      if (
          this.disabled.to.getMonth() >= d.getMonth() &&
          this.disabled.to.getFullYear() >= d.getFullYear()
      ) {
        return true
      }
      return false
    },

    nextMonth () {
      if (this.nextMonthDisabled()) {
        return false
      }
      let d = new Date(this.currDate)
      const daysInMonth = DateUtils.daysInMonth(d.getFullYear(), d.getMonth())
      d.setDate(d.getDate() + daysInMonth)
      this.currDate = d.getTime()
      this.$emit('changedMonth', d)
    },

    nextMonthDisabled () {
      if (this.disabled === null || typeof this.disabled === 'undefined' || typeof this.disabled.from === 'undefined' || !this.disabled.from) {
        return false
      }
      let d = new Date(this.currDate)
      if (
          this.disabled.from.getMonth() <= d.getMonth() &&
          this.disabled.from.getFullYear() <= d.getFullYear()
      ) {
        return true
      }
      return false
    },

    previousYear () {
      if (this.previousYearDisabled()) {
        return false
      }
      let d = new Date(this.currDate)
      d.setYear(d.getFullYear() - 1)
      this.currDate = d.getTime()
      this.$emit('changedYear')
    },

    previousYearDisabled () {
      if (this.disabled === null || typeof this.disabled === 'undefined' || typeof this.disabled.to === 'undefined' || !this.disabled.to) {
        return false
      }
      let d = new Date(this.currDate)
      if (this.disabled.to.getFullYear() >= d.getFullYear()) {
        return true
      }
      return false
    },

    nextYear () {
      if (this.nextYearDisabled()) {
        return false
      }
      let d = new Date(this.currDate)
      d.setYear(d.getFullYear() + 1)
      this.currDate = d.getTime()
      this.$emit('changedYear')
    },

    nextYearDisabled () {
      if (this.disabled === null || typeof this.disabled === 'undefined' || typeof this.disabled.from === 'undefined' || !this.disabled.from) {
        return false
      }
      let d = new Date(this.currDate)
      if (this.disabled.from.getFullYear() <= d.getFullYear()) {
        return true
      }
      return false
    },

    previousDecade () {
      if (this.previousDecadeDisabled()) {
        return false
      }
      let d = new Date(this.currDate)
      d.setYear(d.getFullYear() - 10)
      this.currDate = d.getTime()
      this.$emit('changedDecade')
    },

    previousDecadeDisabled () {
      if (this.disabled === null || typeof this.disabled === 'undefined' || typeof this.disabled.to === 'undefined' || !this.disabled.to) {
        return false
      }
      let d = new Date(this.currDate)
      if (Math.floor(this.disabled.to.getFullYear() / 10) * 10 >= Math.floor(d.getFullYear() / 10) * 10) {
        return true
      }
      return false
    },

    nextDecade () {
      if (this.nextDecadeDisabled()) {
        return false
      }
      let d = new Date(this.currDate)
      d.setYear(d.getFullYear() + 10)
      this.currDate = d.getTime()
      this.$emit('changedDecade')
    },

    nextDecadeDisabled () {
      if (this.disabled === null || typeof this.disabled === 'undefined' || typeof this.disabled.from === 'undefined' || !this.disabled.from) {
        return false
      }
      let d = new Date(this.currDate)
      if (Math.ceil(this.disabled.from.getFullYear() / 10) * 10 <= Math.ceil(d.getFullYear() / 10) * 10) {
        return true
      }
      return false
    },

    /**
     * Whether a day is selected
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedDate (dObj) {
      return this.selectedDate && this.selectedDate.toDateString() === dObj.toDateString()
    },

    /**
     * Whether a day is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledDate (date) {
      let disabled = false

      if (this.disabled === null || typeof this.disabled === 'undefined') {
        return false
      }

      if (typeof this.disabled.dates !== 'undefined') {
        this.disabled.dates.forEach(d => {
          if (date.toDateString() === d.toDateString()) {
            disabled = true
            return true
          }
        })
      }
      if (typeof this.disabled.to !== 'undefined' && this.disabled.to && date < this.disabled.to) {
        disabled = true
      }
      if (typeof this.disabled.from !== 'undefined' && this.disabled.from && date > this.disabled.from) {
        disabled = true
      }
      if (typeof this.disabled.days !== 'undefined' && this.disabled.days.indexOf(date.getDay()) !== -1) {
        disabled = true
      }
      return disabled
    },

    /**
     * Whether a day is highlighted (only if it is not disabled already)
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightedDate (date) {
      if (this.isDisabledDate(date)) {
        return false
      }

      let highlighted = false

      if (this.highlighted === null || typeof this.highlighted === 'undefined') {
        return false
      }

      if (typeof this.highlighted.dates !== 'undefined') {
        this.highlighted.dates.forEach(d => {
          if (date.toDateString() === d.toDateString()) {
            highlighted = true
            return true
          }
        })
      }

      if (this.isDefined(this.highlighted.from) && this.isDefined(this.highlighted.to)) {
        highlighted = date >= this.highlighted.from && date <= this.highlighted.to
      }

      if (typeof this.highlighted.days !== 'undefined' && this.highlighted.days.indexOf(date.getDay()) !== -1) {
        highlighted = true
      }
      return highlighted
    },

    /**
     * Helper
     * @param  {mixed}  prop
     * @return {Boolean}
     */
    isDefined (prop) {
      return typeof prop !== 'undefined' && prop
    },

    /**
     * Whether the selected date is in this month
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedMonth (date) {
      return (this.selectedDate &&
          this.selectedDate.getFullYear() === date.getFullYear() &&
          this.selectedDate.getMonth() === date.getMonth())
    },

    /**
     * Whether a month is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledMonth (date) {
      let disabled = false

      if (this.disabled === null || typeof this.disabled === 'undefined') {
        return false
      }

      if (typeof this.disabled.to !== 'undefined' && this.disabled.to) {
        if (
            (date.getMonth() < this.disabled.to.getMonth() && date.getFullYear() <= this.disabled.to.getFullYear()) ||
            date.getFullYear() < this.disabled.to.getFullYear()
        ) {
          disabled = true
        }
      }
      if (typeof this.disabled.from !== 'undefined' && this.disabled.from) {
        if (
            this.disabled.from &&
            (date.getMonth() > this.disabled.from.getMonth() && date.getFullYear() >= this.disabled.from.getFullYear()) ||
            date.getFullYear() > this.disabled.from.getFullYear()
        ) {
          disabled = true
        }
      }
      return disabled
    },

    /**
     * Whether a year is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedYear (date) {
      return this.selectedDate && this.selectedDate.getFullYear() === date.getFullYear()
    },

    /**
     * Whether a month is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledYear (date) {
      let disabled = false
      if (this.disabled === null || typeof this.disabled === 'undefined' || !this.disabled) {
        return false
      }

      if (typeof this.disabled.to !== 'undefined' && this.disabled.to) {
        if (date.getFullYear() < this.disabled.to.getFullYear()) {
          disabled = true
        }
      }
      if (typeof this.disabled.from !== 'undefined' && this.disabled.from) {
        if (date.getFullYear() > this.disabled.from.getFullYear()) {
          disabled = true
        }
      }

      return disabled
    },

    /**
     * Set the datepicker value
     * @param {Date|String|null} date
     */
    setValue (date) {
      if (typeof date === 'string') {
        let parsed = new Date(date)
        date = isNaN(parsed.valueOf()) ? null : parsed
      }
      if (!date) {
        const d = new Date()
        this.currDate = new Date(d.getFullYear(), d.getMonth(), 1).getTime()
        this.selectedDate = null
        return
      }
      this.selectedDate = date
      this.currDate = new Date(date.getFullYear(), date.getMonth(), 1).getTime()
    },

    init () {
      if (this.value) {
        this.setValue(this.value)
      }
      if (this.isInline()) {
        this.showDayCalendar()
      }

      this.$nextTick(() => {
        this.calendarHeight = this.$el.querySelector('.calendar').getBoundingClientRect().height
      })

      this.$bus.$on('focus-field', this.focusField)
      this.$bus.$on('blur-field', this.blurField)

      this.intervalTimer = setInterval(this.toggleDate, 10)

      document.addEventListener('click', this.onDocumentClick, false)
    },

    /**
     * @param {Object} e
     */
    onDocumentClick (e) {
      if (this.$el && !this.$el.contains(e.target)) {
        if (this.isInline()) {
          return this.showDayCalendar()
        }

        if (this.$refs.date !== document.activeElement) {
          this.close()
        }
      }
    }
  },
  /**
   * Vue 1.x
   */
  ready () {
    this.init()
  }
}
